/* eslint-disable */
export const COMMISSION_TYPES = {
    BASIC: 5,
    STANDARD: 5,
    VIP: 4,
    CHARITY: 3.5
}